<template>
  <div class="form1">
    <div class="story">
      <div class="panel">
        <div class="panel_left">
          <el-form
            :model="form"
            label-width="auto"
            style="max-width: 600px"
            label-position="top"
            :rules="rules"
            ref="ruleForm"
            status-icon
          >
            <el-form-item label="关卡标题" prop="levelTitle">
              <el-input v-model="form.levelTitle" size="large" />
            </el-form-item>
            <el-form-item label="难易度" prop="difficulty">
              <el-rate v-model="form.difficulty" size="large" />
            </el-form-item>
            <el-form-item label="角色提示" prop="selectRole">
              <el-select
                v-model="selectRole2"
                placeholder="Select"
                multiple
                @change="valueChange"
                size="large"
                style="width: 240px"
              >
                <el-option
                  v-for="item in roleOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
              <el-alert
                title="可以使用 。 符号 作为角色信息的分隔标识"
                type="success"
                :closable="false"
                style="margin: 10px 0"
              />
              <el-input
                v-model="form.roleTip"
                type="textarea"
                size="large"
                rows="10"
                placeholder="角色1提示。
角色2提示。"
                maxlength="500"
                show-word-limit
                style="margin-top: 10px"
              />
            </el-form-item>
            <el-form-item label="题目类型" prop="region">
              <el-select v-model="form.region" placeholder="请选择">
                <el-option label="填空题" value="填空题" />
                <el-option label="选择题" value="选择题" />
                <el-option label="AR题" value="AR题" />
              </el-select>
            </el-form-item>
            <el-form-item
              label="关卡谜题内容"
              prop="levelContent"
              v-if="form.region == '填空题'"
              class="animate__animated animate__fadeInLeft"
            >
              <el-input
                v-model="form.levelContent"
                type="textarea"
                size="large"
                rows="10"
                maxlength="800"
                show-word-limit
              />
            </el-form-item>
            <el-form-item
              prop="levelCover"
              class="animate__animated animate__fadeInLeft"
              v-if="form.region == '填空题'"
            >
              <el-upload
                class="avatar-uploader"
                :action="UpdateApi"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
                :limit="1"
                :file-list="fileList"
                :disabled="allowUpload"
              >
                <el-image
                  :src="form.levelCover"
                  v-if="form.levelCover"
                  class="avatar"
                  alt=""
                  :fit="'contain'"
                >
                  <template #error>
                    <div class="image-slot">
                      <el-icon><icon-picture /></el-icon>
                    </div>
                  </template>
                </el-image>
                <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
              </el-upload>
            </el-form-item>
            <el-form-item
              class="animate__animated animate__fadeInLeft"
              v-if="allowUpload && form.region == '填空题'"
            >
              <el-button type="warning" @click="clearImage">{{
                $t("settings.clearImg")
              }}</el-button>
            </el-form-item>
            <el-form-item
              label="关卡答案"
              prop="levelDesc"
              class="animate__animated animate__fadeInLeft"
              v-if="form.region == '填空题'"
            >
              <el-input
                v-model="form.levelDesc"
                type="textarea"
                size="large"
                rows="5"
                maxlength="400"
                show-word-limit
              />
            </el-form-item>
            <!--选择题-->
            <el-alert
              title="提醒"
              type="warning"
              description="请至少包含两个选项否则不会被录入"
              :closable="false"
              v-if="form.region == '选择题'"
            /><br />
            <el-form-item
              v-for="(domain, index) in domains"
              :key="domain.key"
              class="animate__animated animate__fadeInRight"
              :label="'题目' + (index + 1)"
              :prop="'domains.' + index + '.value'"
              v-if="form.region == '选择题'"
            >
              <el-input v-model="domain.value" />
              <el-radio-group v-model="domain.rightAnswer" style="width: 100%">
                <div
                  class="option"
                  v-for="(item2, index2) in domain.options"
                  :key="index2"
                >
                  <el-input v-model="item2.one" style="width: 50%" />
                  <el-radio
                    :value="item2.one"
                    size="large"
                    style="width: 3%; margin-left: 20px"
                  ></el-radio>
                  <p class="text" @click="deleteOption(domain, index2)">删除</p>
                </div>
              </el-radio-group>

              <el-button class="mt-2" @click.prevent="removeDomain(domain)">
                删除
              </el-button>
              <el-button class="mt-2" @click.prevent="addOption(domain)">
                添加选项
              </el-button>
            </el-form-item>
            <el-form-item
              v-if="form.region == '选择题'"
              class="animate__animated animate__fadeInRight"
            >
              <el-button @click="addDomain">添加题目</el-button>
              <el-button @click="resetForm">重置</el-button>
            </el-form-item>
            <!--AR题-->
            <el-form-item
              label="关卡谜题内容"
              prop="arQuestion"
              v-if="form.region == 'AR题'"
              class="animate__animated animate__fadeInLeft"
            >
              <el-input
                v-model="form.arQuestion"
                type="textarea"
                size="large"
                rows="10"
                maxlength="500"
                show-word-limit
              />
            </el-form-item>
            <el-form-item
              prop="arImageRecognition"
              class="animate__animated animate__fadeInLeft"
              v-if="form.region == 'AR题'"
              label="识别图"
            >
              <el-upload
                class="avatar-uploader"
                :action="UpdateApi"
                :show-file-list="false"
                :on-success="handleAvatarSuccess2"
                :before-upload="beforeAvatarUpload"
                :limit="1"
                :file-list="fileList2"
                :disabled="allowUpload2"
              >
                <el-image
                  :src="form.arImageRecognition"
                  v-if="form.arImageRecognition"
                  class="avatar"
                  alt=""
                  :fit="'contain'"
                >
                  <template #error>
                    <div class="image-slot">
                      <el-icon><icon-picture /></el-icon>
                    </div>
                  </template>
                </el-image>
                <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
              </el-upload>
            </el-form-item>
            <el-form-item
              class="animate__animated animate__fadeInLeft"
              v-if="allowUpload2 && form.region == 'AR题'"
            >
              <el-button type="warning" @click="clearImage2">{{
                $t("settings.clearImg")
              }}</el-button>
            </el-form-item>
            <el-form-item
              prop="arImageRecognition"
              class="animate__animated animate__fadeInLeft"
              v-if="form.region == 'AR题'"
              label="内容图"
            >
              <el-upload
                class="avatar-uploader"
                :action="UpdateApi"
                :show-file-list="false"
                :on-success="handleAvatarSuccess3"
                :before-upload="beforeAvatarUpload"
                :limit="1"
                :file-list="fileList3"
                :disabled="allowUpload3"
              >
                <el-image
                  :src="form.arImageContent"
                  v-if="form.arImageContent"
                  class="avatar"
                  alt=""
                  :fit="'contain'"
                >
                  <template #error>
                    <div class="image-slot">
                      <el-icon><icon-picture /></el-icon>
                    </div>
                  </template>
                </el-image>
                <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
              </el-upload>
            </el-form-item>
            <el-form-item
              class="animate__animated animate__fadeInLeft"
              v-if="allowUpload3 && form.region == 'AR题'"
            >
              <el-button type="warning" @click="clearImage3">{{
                $t("settings.clearImg")
              }}</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="panel_right">
          <p class="title" v-if="form.region !== 'AR题'">App示意图</p>
          <div class="example1" v-if="form.region == '填空题'">
            <p>
              <span
                ><el-icon size="20"><ArrowLeft /></el-icon
              ></span>
              <span
                ><el-icon size="20"><QuestionFilled /></el-icon
              ></span>
            </p>
            <p>{{ form.levelTitle }}</p>
            <p>
              <span
                >难度<el-rate v-model="form.difficulty" size="small"
              /></span>
              <span>故事回忆</span>
            </p>
            <p style="white-space: pre-wrap">
              {{ form.levelContent }}
            </p>
            <p>
              <span>此处的线索</span>
              <span>
                <img :src="form.levelCover" alt="" />
              </span>
            </p>
            <p>
              <span>输入答案</span>
            </p>
          </div>
          <div
            class="example2"
            v-if="form.region == '选择题'"
            v-for="(item, index) in domains"
            :key="index"
            v-show="index == selectNumber"
          >
            <p>
              <span
                ><el-icon size="20" @click="changePanel(0)"
                  ><ArrowLeft /></el-icon
              ></span>
              <span
                ><el-icon size="20" @click="changePanel(1)"
                  ><ArrowRight /></el-icon
              ></span>
            </p>
            <p>{{ form.levelTitle }}</p>
            <p>
              <span
                >难度<el-rate v-model="form.difficulty" size="small"
              /></span>
            </p>
            <p>{{ item.value }}</p>
            <p>
              <el-radio-group v-model="radio1">
                <i v-for="(item2, index2) in item.options" :key="index2">
                  <el-radio :value="item2.one" size="large">{{
                    item2.one
                  }}</el-radio>
                </i>
              </el-radio-group>
            </p>
            <p>
              <span>确定</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  computed,
  watch,
  onMounted,
  onUnmounted,
  reactive,
} from "vue";
import {
  Plus,
  ArrowLeft,
  QuestionFilled,
  ArrowRight,
} from "@element-plus/icons-vue";
import { ElNotification, FormRules, UploadProps } from "element-plus";
import router from "@/router";
const validateNotEmpty = (rule: any, value: string, callback: any) => {
  if (value.trim() === "") {
    callback(new Error(rule.message));
  } else {
    callback();
  }
};

export default defineComponent({
  name: "App",
  components: { Plus, ArrowLeft, QuestionFilled, ArrowRight },
  props: ["dataForm"],
  data(): any {
    return {
      form: {
        difficulty: 3,
        levelTitle: "",
        levelCover: "",
        arQuestion: "",
        arImageRecognition: "",
        arImageContent: "",
        levelContent: "",
        levelDesc: "",
        selectRole: "",
        roleTip: "",
        region: "",
        questions: "",
      },
      selectRole2: "",
      fileList: [],
      fileList2: [],
      fileList3: [],
      radio1: "1",
      selectNumber: 0,
      domains: [],
      roleOptions: [],
      roleValue: "",
      dialogImageUrl: "",
      dialogVisible: false,
      rules: reactive<FormRules>({
        levelTitle: [
          {
            required: true,
            message: "故事标题不能为空",
            trigger: "blur",
            validator: validateNotEmpty,
          },
        ],
        levelContent: [
          {
            required: true,
            message: "故事封面不能为空",
            trigger: "blur",
            validator: validateNotEmpty,
          },
        ],
        levelDesc: [
          {
            required: true,
            message: "故事描述不能为空",
            trigger: "blur",
            validator: validateNotEmpty,
          },
        ],
        levelCover: [
          {
            required: true,
            message: "故事描述不能为空",
            trigger: "blur",
            validator: validateNotEmpty,
          },
        ],
        difficulty: [
          {
            required: true,
            message: "故事描述不能为空",
            trigger: "blur",
            validator: validateNotEmpty,
          },
        ],
        region: [
          {
            required: true,
            message: "故事描述不能为空",
            trigger: "blur",
            validator: validateNotEmpty,
          },
        ],
      }),
    };
  },
  computed: {
    doubledCounter(): number {
      return this.counter * 2;
    },
    allowUpload() {
      return !!this.form?.levelCover?.trim();
    },
    allowUpload2() {
      return !!this.form?.arImageRecognition?.trim();
    },
    allowUpload3() {
      return !!this.form?.arImageContent?.trim();
    },
    UpdateApi() {
      return process.env.VUE_APP_Update_API;
    },
  },
  watch: {
    domains: {
      handler(newVal, oldVal) {
        const aa = newVal
          .map((item, index) => {
            if (
              item.options.length >= 2 &&
              item.rightAnswer !== "test123456" &&
              item.rightAnswer !== ""
            ) {
              return item;
            }
          })
          .filter(Boolean); // 过滤掉无效值（undefined 或 null）

        this.form.questions = JSON.stringify(aa);
      },
      immediate: true,
      deep: true, // 可以深度检测到 person 对象的属性值的变化
    },
    dataForm: {
      immediate: true, // 组件加载时立即触发
      deep: true, // 深度监听，确保对象的每个属性变化都被捕获
      handler(newVal) {
        if (newVal) {
          this.updateForm(newVal);
        }
      },
    },
  },
  mounted() {
    this.$store
      .dispatch("game/getRoles", { gameId: this.$route.params.id })
      .then((res: any) => {
        this.roleOptions = res.map((item) => {
          return {
            value: item.roleId,
            label: item.roleName,
          };
        });
      })
      .catch(() => {});
  },
  methods: {
    updateForm(dataForm) {
      this.form.difficulty = dataForm.difficulty;
      this.form.levelTitle = dataForm.levelTitle;
      this.form.levelCover = dataForm.levelCover;
      this.form.arQuestion = dataForm.arQuestion;
      this.form.arImageContent = dataForm.arImageContent;
      this.form.arImageRecognition = dataForm.arImageRecognition;
      this.form.levelContent = dataForm.levelContent;
      this.form.levelDesc = dataForm.levelDesc;
      this.form.region = dataForm.region;
      this.form.questions = dataForm.questions;
      if (dataForm.selectRole != undefined) {
        this.selectRole2 = dataForm.selectRole.split(",");
      }
      this.form.roleTip = dataForm.roleTip;

      if (dataForm.questions) {
        try {
          this.domains = JSON.parse(dataForm.questions);
        } catch (e) {
          console.error("解析 questions 失败：", e);
        }
      }
    },
    handleSave() {
      const { updateTime, ...formWithoutUpdateTime } = this.form;
      console.log(formWithoutUpdateTime);
      this.$store
        .dispatch("game/updateGame", { gameBean: formWithoutUpdateTime })
        .then((res: any) => {})
        .catch(() => {});
    },
    fetchGameList(gameLevelId: string) {
      this.$store
        .dispatch("game/getGameLevelList", { gameLevelId: gameLevelId })
        .then((res: any) => {
          console.log(res);
        })
        .catch((err: any) => {
          console.log(err);
        });
    },
    beforeAvatarUpload(file: File) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPNG) {
        ElNotification.warning({
          message: "请上传png/jpg",
          offset: 100,
          duration: 3000,
        });
        return false;
      }
      if (!isLt2M) {
        ElNotification.warning({
          message: "图片必须小于5m",
          offset: 100,
          duration: 3000,
        });
        return false;
      }

      // const reader = new FileReader();
      // reader.readAsDataURL(file);
      // reader.onload = () => {
      //   this.form.levelCover = reader.result as string;
      // };

      return true;
    },
    handleAvatarSuccess(response: any) {
      this.form.levelCover = response.data.returnFileUrl;
    },
    handleAvatarSuccess2(response: any) {
      this.form.arImageRecognition = response.data.returnFileUrl;
    },
    handleAvatarSuccess3(response: any) {
      this.form.arImageContent = response.data.returnFileUrl;
    },
    handlePictureCardPreview(uploadFile: any): UploadProps["onPreview"] | void {
      this.dialogImageUrl = uploadFile.url!;
      this.dialogVisible = true;
    },
    handleRemove(
      uploadFile: any,
      uploadFiles: any
    ): UploadProps["onRemove"] | void {
      console.log(uploadFile, uploadFiles);
    },
    clearImage() {
      this.form.levelCover = "";
      this.fileList = [];
    },
    clearImage2() {
      this.form.arImageRecognition = "";
      this.fileList2 = [];
    },
    clearImage3() {
      this.form.arImageContent = "";
      this.fileList3 = [];
    },
    removeDomain(item: any) {
      const index = this.domains.indexOf(item);
      if (index !== -1) {
        this.domains.splice(index, 1);
      }
    },
    deleteOption(domain: any, index2: any) {
      this.domains.forEach((item2) => {
        if (item2.key == domain.key) {
          item2.options.splice(index2, 1);
        }
      });
    },
    addDomain() {
      if (this.domains.length < 4) {
        this.domains.push({
          key: Date.now(),
          value: "",
          rightAnswer: "test123456",
          options: [],
        });
      }
    },
    addOption(domain: any) {
      this.domains.forEach((item) => {
        if (item.key == domain.key) {
          if (item.options.length < 4) {
            item.options.push({
              one: "",
              id: Math.floor(Math.random() * 1000),
            });
          }
        }
      });
    },
    changePanel(index: number) {
      if (index == 1) {
        if (this.domains.length - 1 > this.selectNumber) {
          this.selectNumber += 1;
        }
      } else if (index == 0) {
        if (this.selectNumber != 0) {
          this.selectNumber -= 1;
        }
      }
    },
    resetForm() {
      this.domains = [];
    },
    valueChange(value: any) {
      this.form.selectRole = value.join(",");
    },
  },
});
</script>

<style lang="less" scoped>
.panel {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  &_left {
    width: 50%;
  }

  &_right {
    width: 50%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;

    .title {
      margin-bottom: 20px;
      font-size: 1vw;
    }

    .example1 {
      width: 300px;
      height: 550px;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
      border-radius: 10px;
      position: relative;
      box-sizing: border-box;
      padding: 14px;

      p {
        &:nth-child(1) {
          width: 100%;
          height: 30px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          span {
            display: block;
          }
        }
        &:nth-child(2) {
          width: 100%;
          height: auto;
        }
        &:nth-child(3) {
          width: 100%;
          height: 40px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-bottom: 1px solid #e5e1e1;

          span {
            display: block;
            width: 50%;

            &:nth-child(1) {
              display: flex;
              justify-content: flex-start;
              align-items: center;
            }

            &:nth-child(2) {
              display: flex;
              justify-content: flex-end;
              align-items: center;
            }
          }
        }
        &:nth-child(4) {
          width: 100%;
          height: auto;
          min-height: 250px;
          max-height: 250px;
          font-size: 12px;
          overflow-y: scroll;
        }
        &:nth-child(5) {
          width: 100%;
          height: 110px;
          position: relative;

          span {
            &:nth-child(1) {
              position: absolute;
              left: 100px;
              top: 5px;
              color: #2da8e0;
            }

            &:nth-child(2) {
              display: block;
              width: 100%;
              height: 100%;

              img {
                width: 80px;
                height: 80px;
                border-radius: 10px;
                object-fit: contain;
              }
            }
          }
        }
        &:nth-child(6) {
          width: 100%;
          height: 80px;
          border-top: 1px solid rgb(229, 225, 225);
          display: flex;
          justify-content: center;
          align-items: center;

          span {
            width: 150px;
            height: 40px;
            background: rgb(45, 168, 224);
            color: #ffffff;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }
    .example2 {
      width: 300px;
      height: 450px;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
      border-radius: 10px;
      position: relative;
      box-sizing: border-box;
      padding: 14px;
      position: relative;

      p {
        &:nth-child(1) {
          width: 100%;
          height: 30px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          span {
            display: block;
          }
        }
        &:nth-child(2) {
          width: 100%;
          height: auto;
        }
        &:nth-child(3) {
          width: 100%;
          height: 40px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-bottom: 1px solid #e5e1e1;

          span {
            display: block;
            width: 50%;

            &:nth-child(1) {
              display: flex;
              justify-content: flex-start;
              align-items: center;
            }

            &:nth-child(2) {
              display: flex;
              justify-content: flex-end;
              align-items: center;
            }
          }
        }

        &:nth-child(4) {
          box-sizing: border-box;
          padding: 10px;
        }
        &:nth-child(5) {
          width: 100%;
          height: auto;
          min-height: 250px;
          font-size: 12px;

          .el-radio-group {
            width: 100%;

            .el-radio {
              white-space: normal;
              height: auto;
              min-height: 40px;
            }
          }

          i {
            display: block;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        &:nth-child(6) {
          width: 100%;
          height: 80px;
          position: absolute;
          left: calc(50% - 75px);
          bottom: -20px;

          span {
            width: 150px;
            height: 40px;
            background: rgb(45, 168, 224);
            color: #ffffff;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }
  }
}

.box {
  width: 100px;
  height: 100px;
}

.avatar-uploader .avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.el-icon.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  text-align: center;
}

、.avatar-uploader .avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.avatar-uploader {
  border: 1px dashed var(--el-border-color);
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}

.avatar-uploader:hover {
  border-color: var(--el-color-primary);
}

.mt-2 {
  margin-top: 20px;
}

.option {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  .text {
    width: 10%;
    margin-left: 20px;
    font-size: 14px;

    &:hover {
      color: red;
    }
  }
}
</style>
